import * as React from 'react'
import { FocusEvent, FunctionComponent } from 'react'
import { ITextFieldProps, TextField } from '@fluentui/react'
import { mergeStyles } from '@fluentui/react/lib/Styling'

type Props = Omit<ITextFieldProps, 'onFocus'>

const style = mergeStyles({ fontFamily: 'Monaco, Menlo, Consolas, monospace !important' })

const DiagnosticTextField: FunctionComponent<Props> = props => {
    return (
        <TextField
            onFocus={(event: FocusEvent<HTMLTextAreaElement>) => event.target.select()}
            styles={{ field: style, ...(props.styles || {}) }}
            {...props}
        />
    )
}

export default DiagnosticTextField
